import React from 'react';
import PropTypes from 'prop-types';
import RecommendedTargetAmountChart from '../../RecommendedTargetAmountChart/RecommendedTargetAmountChartContainer';

const LargePurchaseGoalChartView = props => {
  const { initialChartData, goalId, clientId, fpId, responseData, isCurrentPlan, title } = props;
  return (
    <>
      <h4>{title}</h4>
      <RecommendedTargetAmountChart
        noContainer
        hasLegend
        title={isCurrentPlan ? 'Savings Schedule' : 'Recommended Savings Schedule'}
        goalId={goalId}
        data={initialChartData ? { GoalCharts: [initialChartData] } : null}
        responseData={responseData}
        clientId={clientId}
        fpId={fpId}
      />
    </>
  );
};

LargePurchaseGoalChartView.defaultProps = {
  initialChartData: null,
  responseData: null,
};

LargePurchaseGoalChartView.propTypes = {
  initialChartData: PropTypes.shape({}),
  responseData: PropTypes.shape({}),
  goalId: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  fpId: PropTypes.string.isRequired,
  isCurrentPlan: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default LargePurchaseGoalChartView;
